(function () {
  // Guard against this file being loaded more than once on the same page
  // (e.g. included by multiple sections) so we never bind duplicate listeners.
  if (window.__scarguardAddToCartLoaded) return;
  window.__scarguardAddToCartLoaded = true;

  // Waits for the cart-drawer / cart-notification custom element to actually
  // be upgraded (its class definition loaded) before using it. On a cold
  // page load the tag can exist in the DOM before its methods are attached;
  // using it too early silently breaks rendering.
  function getCartReady() {
    var el = document.querySelector('cart-drawer') || document.querySelector('cart-notification');
    if (!el) return Promise.resolve(null);

    var tag = el.tagName.toLowerCase();

    if (window.customElements && customElements.get(tag)) {
      return Promise.resolve(el);
    }

    if (window.customElements && typeof customElements.whenDefined === 'function') {
      return customElements.whenDefined(tag).then(function () {
        return el;
      }).catch(function () {
        return el;
      });
    }

    return Promise.resolve(el);
  }

  function handleClick(event) {
    var button = event.target.closest('.scarguard-add-to-cart[data-variant-id]');
    if (!button || button.disabled) return;

    var variantId = button.getAttribute('data-variant-id');
    if (!variantId) return;

    var textEl = button.querySelector('.scarguard-btn-text');
    var originalText = textEl ? textEl.textContent : button.textContent;

    button.disabled = true;
    if (textEl) {
      textEl.textContent = 'Shop Scarguard';
    } else {
      button.textContent = 'Shop Scarguard';
    }

    getCartReady()
      .then(function (cartEl) {
        var body = { items: [{ id: variantId, quantity: 1 }] };

        if (cartEl && typeof cartEl.getSectionsToRender === 'function') {
          body.sections = cartEl.getSectionsToRender().map(function (s) {
            return s.id;
          });
          body.sections_url = window.location.pathname;
        }

        return fetch(window.Shopify.routes.root + 'cart/add.js', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            Accept: 'application/json'
          },
          body: JSON.stringify(body)
        })
          .then(function (res) { return res.json(); })
          .then(function (response) {
            if (response.status) {
              throw new Error(response.description || 'Could not add to cart.');
            }

            if (cartEl && typeof cartEl.renderContents === 'function') {
              cartEl.renderContents(response);
            } else {
              window.location.href = window.Shopify.routes.root + 'cart';
            }
          });
      })
      .catch(function (err) {
        console.error('Add to cart failed:', err);
        alert(err.message || 'Could not add to cart.');
      })
      .finally(function () {
        button.disabled = false;
        if (textEl) {
          textEl.textContent = originalText;
        } else {
          button.textContent = originalText;
        }
      });
  }

  // Delegated listener: works for any current or future
  // .scarguard-add-to-cart button, anywhere on the page, without
  // needing to re-run setup after each section renders.
  document.addEventListener('click', handleClick);
})();
